export enum AbandonedCartStatus {
  NEW = 'New',
  INPROGRESS = 'InProgress',
  COMPLETE = 'Complete',
  RETURNED = 'Returned',
  RETURNINPROGRESS = 'ReturnInProgress',
  RETURNCOMPLETE = 'ReturnComplete'
}

type Address = {
  flatNumber: string;
  houseNumber: string;
  houseName: string;
  addressLine1: string;
  addressLine2: string;
  postalTown: string;
  county: string;
  postcode: string;
  dependentLocality: string;
  doubleDependentLocality: string;
  displayName: string;
  mobileDisplayName: string;
  udprn: number;
};

export type Product = {
  code: string;
  name: string;
  annualAmount: number;
  monthlyAmount: number;
};

type CustomerDetails = {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  phoneNumber?: string;
};

export type AbandonedCart = {
  channel?: 'Direct Sales';
  status: AbandonedCartStatus;
  journey?: {
    journeyURL: string;
    electricityConsumption?: number;
    gasConsumption?: number;
    MPRN?: string;
    MPAN?: string;
    postCode: string;
    meterType: string;
    isTOU: boolean;
    isEconomy7: boolean;
    fuel: string;
    paymentOption: string;
    tariffType: string;
    currentAddress: Address;
  };
  products?: Product[];
  customerDetails?: CustomerDetails;
  updatedTimeStamp?: string;
  createdTimeStamp?: string;
};
